import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=50247be8&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=ts"
export * from "./Swiper.vue?vue&type=script&lang=ts"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=50247be8&prod&lang=scss"
import style1 from "./Swiper.vue?vue&type=style&index=1&id=50247be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50247be8",
  null
  
)

export default component.exports